import React, { useState, useEffect } from "react";
import {  TabPane, Row, Col, Button, Table } from "reactstrap";
import "./index.css";
import ApiCaller from "../../../../api/apiCaller";
import SiteActivityModal from "../SiteActivityModal";
import moment from "moment";
import "moment/locale/vi";
import t from "utils/Lang";

interface SiteActivityTabProps {
  isView: boolean;
  siteId: any;
}

export default function SiteActivityTab({
  isView,
  siteId,
}: SiteActivityTabProps) {
  const [siteActivities, setSiteActivities] = useState<Array<any>>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [showSiteActivityModal, setShowSiteActivityModal] =
    useState<boolean>(false);
  const [isLoadLog, setIsLoadLog] = useState<boolean>(false);
  const [selectedSiteActivity, setSelectedSiteActivity] = useState<any | null>(
    null
  );

  const getSiteActivities = async () => {
    setIsLoadLog(true);
    const uri = `site_activity/?site_id=${siteId}`;
    const res = await ApiCaller.get(uri);
    if (res?.result) {
      setSiteActivities(res?.result);
      setIsLoadLog(false);
    }
  };

  const toogleSiteActivityModal = () => {
    setShowSiteActivityModal(!showSiteActivityModal);
  };

  const onSiteActivityEditClick = (selectedItem: any) => {
    setSelectedSiteActivity(selectedItem);
    setShowSiteActivityModal(true);
  };

  useEffect(() => {
    if (siteId) {
      getSiteActivities();
    }
  }, [currentPage]);

  return (
    <TabPane tabId="site_activity_tab" style={{}}>
      <Row>
        <Col xs={12}>
          <div style={styles.controls}>
            <Button color="primary" size="sm" onClick={toogleSiteActivityModal}>
              <i className="material-icons">add</i>
              <span>{t().action__create_new}</span>
            </Button>
          </div>
        </Col>
      </Row>
      <Table responsive>
        <thead>
          <tr>
            <th style={styles.tableTitle}>{t().site_activity__activity}</th>
            <th style={styles.tableTitle}>{t().site_activity__start}</th>
            <th style={styles.tableTitle}>{t().site_activity__end}</th>
            <th style={styles.tableTitle}>{t().site_activity__note}</th>
          </tr>
        </thead>
        <tbody>
          {siteActivities.map((siteActivity: any) => (
            <tr key={siteActivity?.id}>
              <td>
                <b className="site-activity-list__activity-name">
                  <span onClick={() => onSiteActivityEditClick(siteActivity)}>
                    {siteActivity?.site_activity_type?.name}
                  </span>
                </b>
              </td>
              <td>{moment(siteActivity?.from_date).format("DD/MM/YYYY")}</td>
              <td>{moment(siteActivity?.to_date).format("DD/MM/YYYY")}</td>
              <td>{siteActivity?.note}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      {showSiteActivityModal && (
        <SiteActivityModal
          siteId={siteId}
          siteActivity={selectedSiteActivity}
          isShow={showSiteActivityModal}
          onModalToogle={(isShow: boolean) => setShowSiteActivityModal(isShow)}
          onSaved={getSiteActivities}
        />
      )}
    </TabPane>
  );
}

const styles = {
  controls: {
    paddingTop: 12,
    paddingBottom: 12,
  },
  loadMoreButton: {
    width: "100%",
    marginTop: 12,
    marginBottom: 12,
  },
  tableTitle: {
    borderWidth: 0,
    borderBottomWidth: 2,
    borderColor: "#263F76",
    color: "#263F76",
    minWidth: 200,
  },
};
